import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { IonicModule } from "@ionic/angular";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// material start

import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { ServiceWorkerModule } from "@angular/service-worker";
import { Base64 } from "@ionic-native/base64/ngx";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { IonicStorageModule } from "@ionic/storage";
import { environment } from "../environments/environment";
import { AuthGuard } from "./auth.guard";
import { ManualConfigPageModule } from "./pages/components/manual-config/manual-config.module";
import { ManualCreditNotePageModule } from "./pages/components/manual-credit-note/manual-credit-note.module";
import { ManualHeaderPageModule } from "./pages/components/manual-header/manual-header.module";
import { ManualReplacePageModule } from "./pages/components/manual-replace/manual-replace.module";
import { ManualReportPageModule } from "./pages/components/manual-report/manual-report.module";
import { ManualResendPageModule } from "./pages/components/manual-resend/manual-resend.module";
import { ManualTaxinvoiceEditPageModule } from "./pages/components/manual-taxinvoice-edit/manual-taxinvoice-edit.module";
import { ManualTaxinvoicePageModule } from "./pages/components/manual-taxinvoice/manual-taxinvoice.module";
import { ManualConfigurationPageModule } from "./pages/configuration/components/manual-configuration/manual-configuration.module";
import { ManualCustomerPageModule } from "./pages/configuration/components/manual-customer/manual-customer.module";
import { ManualRoleManagementPageModule } from "./pages/configuration/components/manual-role-management/manual-role-management.module";
import { ManualSellerPageModule } from "./pages/configuration/components/manual-seller/manual-seller.module";
import { ConfigurationDataComponent } from "./pages/configuration/configuration-data/configuration-data.component";
import { ConfigurationDetailComponent } from "./pages/configuration/configuration-detail/configuration-detail.component";
import { CustomerAddComponent } from "./pages/configuration/customer-add/customer-add.component";
import { CustomerDetailComponent } from "./pages/configuration/customer-detail/customer-detail.component";
import { CustomerSearchComponent } from "./pages/configuration/customer-search/customer-search.component";
import { DeleteCustomerModalComponent } from "./pages/configuration/customer-search/delete-customer-modal/delete-customer-modal.component";
import { RoleManagementDataComponent } from "./pages/configuration/role-management-data/role-management-data.component";
import { RoleManagementDetailComponent } from "./pages/configuration/role-management-detail/role-management-detail.component";
import { SellerAddComponent } from "./pages/configuration/seller-add/seller-add.component";
import { DeleteSellerModalComponent } from "./pages/configuration/seller-data/delete-seller-modal/delete-seller-modal.component";
import { SellerDataComponent } from "./pages/configuration/seller-data/seller-data.component";
import { SellerDetailComponent } from "./pages/configuration/seller-detail/seller-detail.component";
import { CreditCheckTaxinvoiceComponent } from "./pages/credit-note/credit-check-taxinvoice/credit-check-taxinvoice.component";
import { CreditNotePreviewComponent } from "./pages/credit-note/credit-note-preview/credit-note-preview.component";
import { CreditNoteTaxListComponent } from "./pages/credit-note/credit-note-tax-list/credit-note-tax-list.component";
import { CreditNoteComponent } from "./pages/credit-note/credit-note.component";
import { CreditSaveTaxinvoiceComponent } from "./pages/credit-note/credit-save-taxinvoice/credit-save-taxinvoice.component";
import { CreditSelectTaxinvoiceComponent } from "./pages/credit-note/credit-select-taxinvoice/credit-select-taxinvoice.component";
import { HomeComponent } from "./pages/home/home.component";
import { LoginComponent } from "./pages/login/login.component";
import { ReplaceCheckdataTaxinvoiceComponent } from "./pages/replace/replace-checkdata-taxinvoice/replace-checkdata-taxinvoice.component";
import { ReplacePreviewComponent } from "./pages/replace/replace-preview/replace-preview.component";
import { ReplaceSavedataTaxinvoiceComponent } from "./pages/replace/replace-savedata-taxinvoice/replace-savedata-taxinvoice.component";
import { ReplaceSelectTaxinvoiceComponent } from "./pages/replace/replace-select-taxinvoice/replace-select-taxinvoice.component";
import { ReplaceComponent } from "./pages/replace/replace.component";
import { ReportDetailComponent } from "./pages/report/report-detail/report-detail.component";
import { ReportDocumentComponent } from "./pages/report/report-document/report-document.component";
import { ReportSendDocumentComponent } from "./pages/report/report-send-document/report-send-document.component";
import { ReportComponent } from "./pages/report/report.component";
import { ResendDetailComponent } from "./pages/resend/resend-detail/resend-detail.component";
import { ResendSelectTaxinvoiceComponent } from "./pages/resend/resend-select-taxinvoice/resend-select-taxinvoice.component";
import { ResendTaxinvoiceComponent } from "./pages/resend/resend-taxinvoice/resend-taxinvoice.component";
import { ResendComponent } from "./pages/resend/resend.component";
import { TaxInvoicePreviewComponent } from "./pages/tax-invoice/tax-invoice-preview/tax-invoice-preview.component";
import { TaxInvoiceSaveComponent } from "./pages/tax-invoice/tax-invoice-save/tax-invoice-save.component";
import { TaxInvoiceSearchBuyProductComponent } from "./pages/tax-invoice/tax-invoice-search-buy-product/tax-invoice-search-buy-product.component";
import { TaxInvoiceEditComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-edit/tax-invoice-edit.component";
import { TaxInvoiceSavedataComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-savedata/tax-invoice-savedata.component";
import { TaxInvoiceSelectComponent } from "./pages/tax-invoice/tax-invoice-select/tax-invoice-select.component";
import { TaxInvoiceComponent } from "./pages/tax-invoice/tax-invoice.component";

import { MatTooltipModule } from "@angular/material/tooltip";
import { BnNgIdleService } from "bn-ng-idle";
import { BackofficeComponent } from "./pages/backoffice/backoffice.component";
import { DeleteFulltaxDetailComponent } from "./pages/backoffice/delete-fulltax-detail/delete-fulltax-detail.component";
import { DeleteFulltaxComponent } from "./pages/backoffice/delete-fulltax/delete-fulltax.component";
import { ExternalReportComponent } from "./pages/backoffice/external-report/external-report.component";
import { LogEtaxDetailComponent } from "./pages/backoffice/log-etax-detail/log-etax-detail.component";
import { LogEtaxComponent } from "./pages/backoffice/log-etax/log-etax.component";
import { UnlockAbbDetailComponent } from "./pages/backoffice/unlock-abb-detail/unlock-abb-detail.component";
import { UnlockAbbComponent } from "./pages/backoffice/unlock-abb/unlock-abb.component";
import { ManualBackofficePageModule } from "./pages/components/manual-backoffice/manual-backoffice.module";
import { ManualNotaxinvoicePageModule } from "./pages/components/manual-notaxinvoice/manual-notaxinvoice.module";
import { NoCreditComponent } from "./pages/credit-note/no-credit/no-credit.component";
import { AddNoTaxinvoiceComponent } from "./pages/no-taxinvoice/add-no-taxinvoice/add-no-taxinvoice.component";
import { CheckNoTaxinvoiceComponent } from "./pages/no-taxinvoice/check-no-taxinvoice/check-no-taxinvoice.component";
import { EditNoTaxinvoiceComponent } from "./pages/no-taxinvoice/edit-no-taxinvoice/edit-no-taxinvoice.component";
import { ModalSaveDraftNoTaxinvoiceComponent } from "./pages/no-taxinvoice/modal-save-draft-no-taxinvoice/modal-save-draft-no-taxinvoice.component";
import { ModalsaveNoTaxinvoiceComponent } from "./pages/no-taxinvoice/modalsave-no-taxinvoice/modalsave-no-taxinvoice.component";
import { NoTaxinvoiceComponent } from "./pages/no-taxinvoice/no-taxinvoice.component";
import { PreviewNoTaxinvoiceComponent } from "./pages/no-taxinvoice/preview-no-taxinvoice/preview-no-taxinvoice.component";
import { SelectNoTaxinvoiceComponent } from "./pages/no-taxinvoice/select-no-taxinvoice/select-no-taxinvoice.component";
import { reportEndDayComponent } from "./pages/report-end-day/report-end-day.component";
import { ModalSaveDraftComponent } from "./pages/tax-invoice/modal-save-draft/modal-save-draft.component";
// import {MatChipsModule} from '@angular/material/chips';
// material end

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResendComponent,
    HomeComponent,
    ReplaceSelectTaxinvoiceComponent,
    ReplaceCheckdataTaxinvoiceComponent,
    ReplaceSavedataTaxinvoiceComponent,
    ReplaceComponent,
    TaxInvoiceSaveComponent,
    ModalSaveDraftComponent,
    ModalSaveDraftNoTaxinvoiceComponent,
    TaxInvoiceSearchBuyProductComponent,
    TaxInvoiceSelectComponent,
    TaxInvoiceComponent,
    TaxInvoicePreviewComponent,
    TaxInvoiceEditComponent,
    CreditSelectTaxinvoiceComponent,
    CreditCheckTaxinvoiceComponent,
    CreditSaveTaxinvoiceComponent,
    ReportDocumentComponent,
    ReportComponent,
    ReportSendDocumentComponent,
    ResendSelectTaxinvoiceComponent,
    ResendTaxinvoiceComponent,
    TaxInvoiceSavedataComponent,
    CreditNoteComponent,
    ReplacePreviewComponent,
    CreditNotePreviewComponent,
    ReportDetailComponent,
    CreditNoteTaxListComponent,
    ResendDetailComponent,
    CustomerSearchComponent,
    SellerDataComponent,
    ConfigurationDataComponent,
    RoleManagementDataComponent,
    CustomerDetailComponent,
    SellerDetailComponent,
    ConfigurationDetailComponent,
    RoleManagementDetailComponent,
    CustomerAddComponent,
    SellerAddComponent,
    DeleteSellerModalComponent,
    DeleteCustomerModalComponent,
    NoTaxinvoiceComponent,
    SelectNoTaxinvoiceComponent,
    EditNoTaxinvoiceComponent,
    AddNoTaxinvoiceComponent,
    CheckNoTaxinvoiceComponent,
    PreviewNoTaxinvoiceComponent,
    ModalsaveNoTaxinvoiceComponent,
    NoCreditComponent,
    reportEndDayComponent,
    ExternalReportComponent,
    DeleteFulltaxComponent,
    LogEtaxComponent,
    DeleteFulltaxDetailComponent,
    LogEtaxDetailComponent,
    BackofficeComponent,
    UnlockAbbComponent,
    UnlockAbbDetailComponent,
  ],
  entryComponents: [
    LoginComponent,
    ResendComponent,
    ReplaceSelectTaxinvoiceComponent,
    ReplaceCheckdataTaxinvoiceComponent,
    ReplaceSavedataTaxinvoiceComponent,
    ReplaceComponent,
    TaxInvoiceSaveComponent,
    ModalSaveDraftComponent,
    ModalSaveDraftNoTaxinvoiceComponent,
    TaxInvoiceSearchBuyProductComponent,
    TaxInvoiceSelectComponent,
    TaxInvoiceEditComponent,
    TaxInvoiceComponent,
    TaxInvoicePreviewComponent,
    CreditSelectTaxinvoiceComponent,
    CreditCheckTaxinvoiceComponent,
    CreditSaveTaxinvoiceComponent,
    ReportDocumentComponent,
    ReportComponent,
    ReportSendDocumentComponent,
    ResendSelectTaxinvoiceComponent,
    ResendTaxinvoiceComponent,
    TaxInvoiceSavedataComponent,
    ReplacePreviewComponent,
    CreditNotePreviewComponent,
    ReportDetailComponent,
    CreditNoteTaxListComponent,
    CustomerSearchComponent,
    SellerDataComponent,
    ConfigurationDataComponent,
    RoleManagementDataComponent,
    CustomerDetailComponent,
    SellerDetailComponent,
    ConfigurationDetailComponent,
    RoleManagementDetailComponent,
    CustomerAddComponent,
    SellerAddComponent,
    DeleteSellerModalComponent,
    DeleteCustomerModalComponent,
    NoTaxinvoiceComponent,
    SelectNoTaxinvoiceComponent,
    EditNoTaxinvoiceComponent,
    AddNoTaxinvoiceComponent,
    CheckNoTaxinvoiceComponent,
    PreviewNoTaxinvoiceComponent,
    ModalsaveNoTaxinvoiceComponent,
    NoCreditComponent,
    ExternalReportComponent,
    DeleteFulltaxComponent,
    LogEtaxComponent,
    DeleteFulltaxDetailComponent,
    LogEtaxDetailComponent,
    BackofficeComponent,
    UnlockAbbComponent,
    UnlockAbbDetailComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatChipsModule,
    ManualHeaderPageModule,
    ManualReplacePageModule,
    ManualConfigPageModule,
    ManualTaxinvoicePageModule,
    ManualTaxinvoiceEditPageModule,
    ManualCreditNotePageModule,
    ManualReportPageModule,
    ManualResendPageModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ManualSellerPageModule,
    ManualCustomerPageModule,
    ManualConfigurationPageModule,
    ManualRoleManagementPageModule,
    ManualNotaxinvoicePageModule,
    ManualBackofficePageModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthGuard,
    BnNgIdleService,
    Base64,
    Clipboard,
    InAppBrowser,
    // { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    // {provide: APP_BASE_HREF, useValue: "/Einvoice"},
    // { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
